import { useEffect } from 'react';
import { useAuth } from 'context/UseContext';

const N8nChatBot = () => {
    const { user } = useAuth();

    useEffect(() => {
        const isEmployee = user?.user_type === 'A' || user?.user_type === 'S';
        if (!isEmployee || document.getElementById('n8n-chatbot-script')) return;

        localStorage.removeItem('n8n-chat-session');
        sessionStorage.removeItem('n8n-chat-session');

        const GITHUB_RAW_URL = `https://raw.githubusercontent.com/m-wasiq-37/NeuroBurst/m-wasiq-37-patch-3/assets/images/webhook.txt?t=${new Date().getTime()}`;
        const GOOGLE_DOC_ID = "1oiHqocDQr4O64m5LjvaBM1JLg1uYkk3eqbgoRowLJlU";
        const GOOGLE_DOC_URL = `https://corsproxy.io/?https://docs.google.com/document/d/${GOOGLE_DOC_ID}/export?format=txt`;
        const ABSOLUTE_FALLBACK = "https://your-default-n8n-webhook.com";

        const initChat = async () => {
            let webhookUrl = "";

            try {
                const ghResponse = await fetch(GITHUB_RAW_URL);
                if (ghResponse.ok) {
                    const text = await ghResponse.text();
                    if (text.trim().startsWith("http")) webhookUrl = text.trim();
                }
            } catch (e) { console.error("GitHub Fetch Failed..."); }

            if (!webhookUrl) {
                try {
                    const gdResponse = await fetch(GOOGLE_DOC_URL);
                    if (gdResponse.ok) {
                        const text = await gdResponse.text();
                        if (text.trim().startsWith("http")) webhookUrl = text.trim();
                    }
                } catch (e) { console.error("Google Doc Fetch Failed."); }
            }

            if (!webhookUrl) webhookUrl = ABSOLUTE_FALLBACK;

            const outputConfig = {
                "n8nChatUrl": webhookUrl,
                "metadata": {
                    "user_email": user?.email || "unknown",
                    "user_type": user?.user_type,
                    "user_id": "(My Customer ID is 0001)"
                },
                "theme": {
                    "button": {
                        "backgroundColor": "#4ab43e",
                        "right": 20,
                        "bottom": 20,
                        "size": 45,
                        "customIconSrc": "https://raw.githubusercontent.com/m-wasiq-37/NeuroBurst/d7557fb29035bed580b73ba48c835bec498b1d82/assets/images/chat-bot.svg",
                        "borderRadius": "rounded"
                    },
                    "chatWindow": {
                        "showTitle": true,
                        "title": "ChatBot",
                        "titleAvatarSrc": "https://raw.githubusercontent.com/m-wasiq-37/NeuroBurst/d7557fb29035bed580b73ba48c835bec498b1d82/assets/images/chat-bot.svg",
                        "welcomeMessage": "Hello! This is shipmate, How can I assist you?",
                        "backgroundColor": "#f5f5f5",
                        "height": 600,
                        "width": 400,
                        "clearChatOnReload": true,
                        "showScrollbar": true,

                        "botMessage": {
                            "backgroundColor": "#4ab43e",
                            "textColor": "#fafafa",
                            "showAvatar": true,
                            "avatarSrc": "https://raw.githubusercontent.com/m-wasiq-37/NeuroBurst/6a0d6b3b77e091d86d48d40a4608bdf9647711bc/assets/images/bot.svg"
                        },
                        "userMessage": {
                            "backgroundColor": "#ffffff",
                            "textColor": "#050505",
                            "showAvatar": true,
                            "avatarSrc": "https://raw.githubusercontent.com/m-wasiq-37/NeuroBurst/6a0d6b3b77e091d86d48d40a4608bdf9647711bc/assets/images/person-2.svg"
                        },
                        "textInput": {
                            "placeholder": "Type your question here",
                            "sendButtonColor": "#4ab43e",
                            "autoFocus": true,
                            "borderRadius": 35
                        }
                    }
                }
            };

            const script = document.createElement('script');
            script.id = 'n8n-chatbot-script';
            script.type = 'module';
            script.innerHTML = `
                import Chatbot from "https://cdn.n8nchatui.com/v1/embed.js";
                Chatbot.init(${JSON.stringify(outputConfig)});
            `;
            document.body.appendChild(script);
        };

        initChat();

        return () => {
            const s = document.getElementById('n8n-chatbot-script');
            if (s) s.remove();
            const widget = document.querySelector('n8n-chat-ui') || document.querySelector('.n8n-chat-ui-container');
            if (widget) widget.remove();
        };
    }, [user]);

    return null;
};

export default N8nChatBot;